if (typeof NHS === 'undefined') {
    NHS = {};
    NHS.Scripts = {};
}
NHS.Scripts.Account = function (parameters) {
    this.urlBase = parameters.urlBase || '';
    this.pictureUrl = parameters.pictureUrl || '';
    this.params = parameters;

    this.keepMeLoggedInCookie = !parameters.keepMeLoggedInCookie && (parameters.keepMeLoggedInCookie == 'True');

    if (parameters.logParams) {
        this.logger = new NHS.Scripts.Globals.EventLogger(parameters.logParams);
    }
};

NHS.Scripts.Account.prototype =
{
    initialize: function () {
        var self = this;

        // Enter key for login, register, recovery forms
        jQuery(document).on("keypress", "#nhs_LoginForm, #nhs_RecoverForm, #nhs_AccountForm", function (e) {
            if (e.which === 13) {
                if (jQuery(e.srcElement).val() != '')
                    jQuery(this).find('input[type="submit"],input[type="button"]')[0].click();
                else
                    jQuery(e.srcElement).next().focus();
            }
        });
    },

    initializeMyAccount: function () {
        var self = this;
        const passwordInputs = document.querySelectorAll("[data-password-input]");
        const addRequired = function () {
          passwordInputs.forEach(item => {
            let label = item.labels[0];
            label.textContent = '*' + label.textContent;
            item.required = true;
            item.removeEventListener('input', addRequired);
          });
        };

        var checkboxNewsletter = document.querySelector('[data-news-letter]');
        if (checkboxNewsletter) {
          checkboxNewsletter.addEventListener('click', function () {
            checkboxNewsletter.value = checkboxNewsletter.checked;
          });
        }

        passwordInputs.forEach(item => {
          item.addEventListener('input', addRequired); 
        });
        var ZipCode = document.getElementById("ZipCode");
        var Phone = document.getElementById("Phone");

        if (self.pictureUrl != '') {
            jQuery("#nhs_uploadButtom").text(self.params.changeImageText);
        }

        const phoneInput = document.querySelector('[name=BusinessPhone]');
        if (phoneInput) {
          window.VMasker(phoneInput).maskPattern('(999) 999-9999');
        }

        var nonInternationalPanelShow = self.params.InternationalPhone;
        if (!nonInternationalPanelShow && ZipCode && Phone) {
            ZipCode.removeAttribute("disabled");
            Phone.removeAttribute("disabled");
        }
        
        jQuery("#InternationalPhone").change(function () {            
            jQuery('#nonInternationalPanel').toggle(nonInternationalPanelShow);            
            if (!nonInternationalPanelShow) {                 
                ZipCode.setAttribute("disabled", "");
                Phone.setAttribute("disabled", "");
            }
            else {                           
                ZipCode.removeAttribute("disabled");
                Phone.removeAttribute("disabled");                
            }
            nonInternationalPanelShow = !nonInternationalPanelShow;
        });

        jQuery(".scrollTo").click(function (event) {
            jQuery('html,body').animate({ scrollTop: jQuery(jQuery(this).data('scrollid')).offset().top }, 1000);
        });
        
        self.setupProfileImageControls();

        jQuery("#btnUpdate").click(async function () {
            var valid = true;
            var form = jQuery('.nhs_ManageAccount fieldset.main');

            jQuery(this).hide();
            jQuery("#btnUpdateFake").show();
            jQuery('.validation-summary-errors span').hide();

            var ul = jQuery("#nhs_Errors");

            jQuery('#nhs_Errors li').hide();

            var oForm = document.querySelector("[data-info-form]");
            var valid = await formValidator.validateForm(oForm);

            if (valid) {
                var info = jQuery(".nhs_ManageAccount input, select").serialize();                
                jQuery.ajax({
                    type: "Post",
                    url: self.params.UpdateAccount,
                    data: info,
                    success: function (data) {
                        jQuery("#btnUpdateFake").hide();
                        jQuery("#btnUpdate").show();

                        if (data.Saved) {
                            alert(self.params.Message);

                            if (jQuery('#modal-content').length) {
                              window.NewHomeSource.ModalLoader.hideModal();
                            } else {
                                jQuery('.validation-summary-errors span').hide();
                            }

                            if (jQuery('#nhs_FacebookSection').length > 0 && !jQuery('#IsFbAccount').is(':checked')) {
                                FB.api("/me/permissions", "DELETE", function callback() { });
                                jQuery('#nhs_FacebookSection').hide();
                            }

                        } else {
                            jQuery(".validation-summary-errors").show();
                            jQuery("#nhs_Errors").empty().html('<li>' + data.ErrorMsg.join('</li><li>') + '</li>');
                            jQuery('.validation-summary-errors span').show();
                            jQuery(".nhs_ManageAccount").ScrollTo();
                        }
                    }
                });
            } else {
                //jQuery('.validation-summary-errors span').show();
                jQuery(this).show();
                jQuery("#btnUpdateFake").hide();
                jQuery("#btnUpdate").show();
                jQuery(".nhs_ManageAccount").ScrollTo();

            }
        });
    },

    initializeFavorites: function () {
        var self = this;

        const createAccountButton = document.querySelector("[data-component='create-account']");
        const createAccountLink = document.querySelector("[component='create-account-link']");

        if (createAccountButton && createAccountLink) {
          createAccountButton.addEventListener("click",
            function () {
              createAccountLink.click();
            });
        }

        if (self.pictureUrl != '') {
            jQuery("#nhs_uploadButtom").text(self.params.changeImageText);
        }

        jQuery(".scrollTo").click(function (event) {
            jQuery('html,body').animate({ scrollTop: jQuery(jQuery(this).data('scrollid')).offset().top }, 1000);
        });

        self.setupProfileImageControls();

        jQuery('#nhs_SavedPropItems .btn_FreeBrochure').on('click', function () {
            NHS.Scripts.Helper.createCookie('CTAName', 'Saved Properties CTA Free Brochure');
        });

        jQuery("#MyAccountSavedHomes").on("click", ".result, .nhs_CommResItem, .nhs_HomeResItem, .card-custom", function (event) {
            if (jQuery(event.srcElement).is('.nhs_ShareLink') || jQuery(event.srcElement).is('.btn_RequestAppointment') || jQuery(event.srcElement).is('.btn_FreeBrochure') || jQuery(event.srcElement).is('.info__review-link') 
            || event.target.getAttribute('data-load-modal'))
                return;

            if (event.type === "click") {
                var url = jQuery(this).find("a:first-of-type").attr("href");
                window.location.href = url;
                return false;
            }
        });

        jQuery("#MyAccountSavedComms").on("click", ".result, .nhs_CommResItem, .nhs_HomeResItem, .card-custom", function (event) {
          const priceReductionLink = event.target.closest('[data-price-reduction]');

          if (jQuery(event.srcElement).is('.nhs_ShareLink') ||
            jQuery(event.srcElement).is('.btn_RequestAppointment') ||
            jQuery(event.srcElement).is('.btn_FreeBrochure') ||
            jQuery(event.srcElement).is('.info__review-link') ||
            priceReductionLink) {
            return;
          }

          if (event.type === "click") {
            var url = jQuery(this).find("a:first-of-type").attr("href");
            window.location.href = url;
            return false;
          }
        });

        jQuery(".result, .nhs_CommResItem, .nhs_HomeResItem").on("click", ".nhs_MyFavoritesItemMenu", function (event) {
            if (jQuery(event.srcElement).is('.nhs_ShareLink') || jQuery(event.srcElement).is('.btn_RequestAppointment') || jQuery(event.srcElement).is('.btn_FreeBrochure'))
                return;

            event.preventDefault();
            if (event.stopPropagation) event.stopPropagation();
        });

        jQuery(".result, .nhs_CommResItem, .nhs_HomeResItem").on("click", ".nhs_MyFavoritesItemMenu > span", function (event) {
            jQuery(this).toggleClass("nhs_Active");
            jQuery(this).parent().find("ul").toggle();
        });

        jQuery(window).click(function () {
            jQuery(".nhs_MyFavoritesItemMenu > span").removeClass("nhs_Active");
            jQuery(".nhs_MyFavoritesItemMenu > span").parent().find("ul").hide();
        });


        jQuery(".nhs_DeleteFav").unbind().click(function () {
            var deleteElement = jQuery(this);
            if (deleteElement.length > 0)
                jQuery.ShowLoading();

            var favId = jQuery(deleteElement).data("id");
            var data = { id: favId };
            jQuery.ajax({
                type: "Post",
                url: self.params.DeleteFavorite,
                data: data,
                success: function (result) {
                    if (result.Saved) {
                        var type = jQuery("#" + result.Id).attr('class').split(" ")[0];
                        var countControl = deleteElement.closest('.nhs_favoritesSection').find('.nhs_total');
                        jQuery("#" + result.Id).remove();
                        countControl.html(jQuery("." + type).length);

                        document.body.dispatchEvent &&
                          document.body.dispatchEvent(new CustomEvent("trackIdentifySaveItems", {
                            detail: { data: deleteElement[0] }
                          }));
                    }
                    jQuery.HideLoading();
                }
            });

        });

        var shouldBindTriggers = false;
        jQuery(".btn_RequestAppointment").mousedown(function () {
            if (shouldBindTriggers) {
                return;
            }
            window.NewHomeSource.ModalLoader.initTrigger('.btn_RequestAppointment ', function () {
                overlay = document.querySelector('#nhs_OverlayPanelCTAGlobal');
                if (overlay) {
                  overlay.classList.add("is-visible");
                  document.body.setAttribute("class", "nhs_NoScrollComplete");
                  const cssBundle = this.document.querySelector('#modalFavMobileCssBundle');

                  require(["loadCss"],
                    function (loadCss) {
                      if (cssBundle) {
                        loadCss(cssBundle.value);
                        cssBundle.parentElement.removeChild(cssBundle);
                      }
                    });
                }
                setTimeout(function () {
                    var date = new Date();
                    date.setDate(date.getDate() + 1);
                    var currentMonth = date.getMonth();
                    var currentDate = date.getDate();
                    var currentYear = date.getFullYear();
                    jQuery(".modal_div #RequestBrochureDate").datepicker({
                        minDate: new Date(currentYear, currentMonth, currentDate)
                    });
                    jQuery(".modal_div #RequestBrochureDate").attr("disabled", "disabled");
                    jQuery('.modal_div .nhs_PickerIconModal').click(function () {
                        jQuery('.modal_div #RequestBrochureDate').datepicker("show");
                        var container = document.querySelector(".nhs_RequestInfoForm");
                        var specId = container.querySelector("[name='SpecId']").value;
                        var planId = container.querySelector("[name='PlanId']").value;
                        var commId = container.querySelector("[name='CommunityId']").value;
                        var phoneId;
                        if (specId !== "0") {
                            phoneId = specId;
                        } else if (planId !== "0") {
                            phoneId = planId;
                        } else {
                            phoneId = commId;
                        }
                        var element = document.querySelector("[data-phone='" + phoneId + "']");
                        var culture = document.documentElement.lang || "en";
                        var atWord = culture === "en" ? "at" : "";
                        var alertText = self.params.alertText + " " + (element ? atWord + " " + element.innerText : "");
                        var containerDatepicker = document.getElementById("ui-datepicker-div");
                        containerDatepicker.classList.add("datepicker-modal");
                        var datePicker = new Datepicker({
                            queryElement: ".ui-datepicker-today",
                            alertText: alertText
                        });
                        containerDatepicker.addEventListener("click", function () {
                            datePicker.attachEventsToNotAvailableDay();
                        });
                        datePicker.attachEventsToNotAvailableDay();
                    });
                }, 1000);
            });
            shouldBindTriggers = true;            
        });

        document.addEventListener('click', closeModal);
        function closeModal(event) {
          const modalLoading = document.querySelector('#modal-loading');
            if (event.target.closest('[data-modal-close-element]') && !modalLoading) {
              overlay = document.querySelector('#nhs_OverlayPanelCTAGlobal');
              if (overlay) {
                overlay.classList.remove("is-visible");
                document.body.removeAttribute("class", "nhs_NoScrollComplete");
              }
            }
        };

        jQuery(".nhs_CommResultsRow, .nhs_HomeResultsRow").on("click", function (e) {
            if (e.srcElement.className.indexOf('btn_RequestAppointment') < 0 &&
                e.srcElement.className.indexOf('nhs_SavedCommDelete') < 0 &&
                e.srcElement.className.indexOf('nhs_SavedHomeDelete') < 0 &&
                e.srcElement.className.indexOf('nhs_BrandImageElement') < 0 &&
                e.srcElement.className.indexOf('nhs_ShareLink') < 0) {
                var url = jQuery("#" + e.currentTarget.id).find("a:first-of-type").attr("href");
                window.location.href = url;
                return false;
            }
        });

        jQuery(".nhs_DeleteBtn").click(function () {
            var id = jQuery(this).closest("ul").data("id");
            var elementErased = jQuery(this).closest("ul").closest("li");
            if (id === undefined) {
                id = jQuery(this).closest("li").data("id");
                elementErased = jQuery(this).closest("li");
            }
            var data = { contentId: id };
            jQuery.ajax({
                type: "POST",
                url: self.params.RemoveCheckListAndArticles,
                data: data,
                success: function (result) {
                    if (result.completed === true) {
                        jQuery(elementErased).remove();
                    }
                }
            });

        });

        jQuery(document).on('click', '.nhs_Row', function (event) {
          const priceReductionLink = event.target.closest('[data-price-reduction]');
          if (event.target.className.includes('nhs_ModalPopUp') || priceReductionLink) {
            return;
          }

          jQuery.CancelEventAndStopPropagation(event);
          if (event.type === "click") {
            var url;
            url = jQuery(this).find("a:first-of-type").attr("href");
            window.location.href = url;
          }
        });

        jQuery(document).on('click', '.nhs_CallBtn', function () {
            self.params.builderId = jQuery(this).data("builderid");
            self.params.communityId = jQuery(this).data("communityid");
            self.params.marketId = jQuery(this).data("marketid");
            self.params.specId = jQuery(this).data("specid");
            self.params.planId = jQuery(this).data("planid");
            self.params.isCallTracking = jQuery(this).data("iscalltracking");

            self.logger.logEventWithParameters(self.params.MobileCallTrackingEvent, self.params);
            if (self.params.isCallTracking !== "True")
                self.logger.logEventWithParameters(self.params.MobilePhoneClicknonParticipating, self.params);

        });


        jQuery(document).on("click", ".nhs_CallBtn, .nhs_ViewBrochureBtn", function (event) {
            event.stopPropagation();
        });

        jQuery(document).on("click", "#nhs_savedHomesCommunities", function () {
            jQuery("#nhs_checklistAndArticles").hide();
            jQuery("#nhs_ResList").show();
            jQuery("#nhs_savedHomesCommunities").parent().addClass("nhs_Active");
            jQuery("#nhs_shoppingKit").parent().removeClass("nhs_Active");
        });


        jQuery(".nhs_HomeResItemDelete").click(function (event) {
            jQuery.CancelEventAndStopPropagation(event);
            var control = jQuery(this);
            var parent = control.parent().parent().parent();
            parent.ShowLoading();
            var isSpec = control.data('isplan');
            var listingId = control.data('listingid');
            var data = { isSpec: isSpec, listingId: listingId };
            jQuery.ajax({
                type: "POST",
                url: self.params.DeleteFavoriteHome,
                data: data,
                success: function (result) {
                    if (result.valid) {
                        parent.remove();
                        var rows = jQuery(".nhs_HomeItem").length;
                        jQuery("#nhs_totalHomes").html(rows);
                    }
                }
            });
        });

        jQuery(".nhs_CommResItem .nhs_DeleteBtn").click(function (event) {
            jQuery.CancelEventAndStopPropagation(event);
            var control = jQuery(this);
            var parent = control.parent().parent().parent();
            parent.ShowLoading();
            var builderId = control.data('builderid');
            var communityId = control.data('communityid');
            var data = { builderId: builderId, communityId: communityId };
            jQuery.ajax({
                type: "POST",
                url: self.params.DeleteFavoriteComm,
                data: data,
                success: function (result) {
                    if (result.valid) {
                        parent.remove();
                        var rows = jQuery(".nhs_CommResItem").length;
                        jQuery("#nhs_totalComms").html(rows);
                    }
                }
            });

        });
    },

    initBoxScrolling: function (col1, col2, adj) {
        var col1 = col1;
        var col2 = col2;
        var adj = adj;

        if (jQuery(col2).length > 0) {
            //floating column
            jQuery(col2).css("position", "relative");
            jQuery(col2 + " > div").css({
                "position": "static",
                "z-index": "99999"
            });

            var col1Height = jQuery(col1).height();
            var col2Height = jQuery(col2 + " > div").height();

            var col1Bottom = col1Height + jQuery(col2).offset().top;
            var col2Top = col1Height - col2Height - 10;
            var col2Bottom = col2Height + jQuery(col2).offset().top;

            var browserHeight = jQuery(window).height();
            var browserBottomY;

            jQuery(window).scroll((function (event) {
                col2Height = jQuery(col2 + " > div").height();
                // what the y position of the scroll is
                var y = jQuery(document).scrollTop();
                col1Height = jQuery(col1).height();

                col1Bottom = col1Height + jQuery(col2).offset().top;

                col2Top = jQuery(col2).offset().top;
                col2Bottom = col2Height + jQuery(col2).offset().top;
                browserHeight = jQuery(window).height();
                browserBottomY = y + browserHeight;
                //console.log("col1Height: " + col1Height);
                //console.log("col2Height: " + col2Height);

                //console.log("col1Bottom: " + col1Bottom);

                //console.log("col2Top: " + col2Top);
                //console.log("col2Bottom: " + col2Bottom);

                // is list column longer than ad column
                if (col1Bottom > col2Bottom) {
                    // whether scroll is below the ad's top position
                    if (y >= (col2Top)) {
                        // if so, ad the fixed class          
                        if (y > (col1Bottom - col2Height - adj)) {
                            col2Top = col1Height - col2Height - adj;
                            jQuery(col2 + " > div").css({
                                "position": "absolute",
                                "top": (col2Top + "px"),
                                "bottom": "auto"
                            });
                        } else {
                            jQuery(col2 + " > div").css({
                                "position": "fixed",
                                "top": 0,
                                "bottom": "auto"
                            });
                        }
                    } else {
                        // otherwise remove it
                        jQuery(col2 + " > div").css({
                            "position": "static",
                            "top": "auto",
                            "bottom": "auto"
                        });
                    }
                }

            }).bind(this));
        }
    },

    setupProfileImageControls: function () {
        var self = this;

        //Croppic
        var userImageOptions = {
            cropW: 400,
            cropH: 400,
            zoom: 10,
            processInline: true,
            modal: true,
            doubleZoomControls: false,
            rotateControls: false,
            imgEyecandyOpacity: 0.4,
            customUploadButtonId: 'nhs_uploadButtom',
            onAfterImgCrop: self.saveImage.bind(self)
        };

        self.cropperHeader = new Croppic('nhs_ProfileImage', userImageOptions);
    },

    saveImage: function (response) {
        var self = this;
        jQuery.ajax({
            type: "POST",
            url: self.urlBase + '/account/UpdateUserImageProfile',
            dataType: "json",
            data: { 'imageUrl': response.url },
            success: function (data) {
                if (data.success) {
                    jQuery("#nhs_uploadImage").text(self.params.changeImageText);
                } else {
                    // Show error in validation container if it exists, otherwise console error
                    if (jQuery(".validation-summary-errors").length > 0) {
                        jQuery(".validation-summary-errors").show();
                        jQuery("#nhs_Errors").empty().html('<li>' + data.message + '</li>');
                        jQuery('.validation-summary-errors span').show();
                    }
                    console.error("UpdateUserImageProfile failed:", data.error || data.message);
                }
            },
            error: function (xhr, status, error) {
                // Show error in validation container if it exists
                if (jQuery(".validation-summary-errors").length > 0) {
                    jQuery(".validation-summary-errors").show();
                    jQuery("#nhs_Errors").empty().html('<li>An error occurred while updating your profile image.</li>');
                    jQuery('.validation-summary-errors span').show();
                }
                console.error("AJAX error:", error);
            }
        });
    }
};